// @ vendors
const Immutable = require('immutable');

// @ constants
const { FLOW_STEPS, WIZARD_REQUEST_RESPONSE_OPTIONS } = require('../../insuranceConstants/insuranceRequestHome');
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP, FIFTH_STEP } = require('constants/index');
const actionTypes = require('../../insuranceConstants/actionTypes');

// @ reducers
const insuranceRequestWizardStep1 = require('./insuranceRequestWizardStep1');
const insuranceRequestWizardStep2 = require('./insuranceRequestWizardStep2');
const insuranceRequestWizardStep3 = require('./insuranceRequestWizardStep3');
const insuranceRequestWizardStep4 = require('./insuranceRequestWizardStep4');
const insuranceRequestWizardStep5 = require('./insuranceRequestWizardStep5');

const stepsReducerList = [
    insuranceRequestWizardStep1,
    insuranceRequestWizardStep2,
    insuranceRequestWizardStep3,
    insuranceRequestWizardStep4,
    insuranceRequestWizardStep5
];

const setInitialState = () => {
    return Immutable.Map().merge({
        steps: [
            insuranceRequestWizardStep1(undefined, { type: null }),
            insuranceRequestWizardStep2(undefined, { type: null }),
            insuranceRequestWizardStep3(undefined, { type: null }),
            insuranceRequestWizardStep4(undefined, { type: null }),
            insuranceRequestWizardStep5(undefined, { type: null })
        ],
        isFetching: false,
        isLoadingFromPublic: false,
        visibleStep: 1,
        error: '',
        wizardRequestResponse: WIZARD_REQUEST_RESPONSE_OPTIONS.NO_PROCESS,
        policyDocument: {
            policyPdfUrl: '',
            policyPdfBase64: '',
            policyPdfName: '',
            policyPdfType: ''
        }
    });
};

const updateStep = (steps, stepNumber, action) => {
    return steps.update(stepNumber, step => {
        return stepsReducerList[stepNumber](step, action);
    });
};

const insuranceRequestWizard = (state = setInitialState(), action) => {
    let step;
    let partialSteps;
    let visibleStep;
    let isLoadingFromPublic;

    switch (action.type) {
        case actionTypes.INSURANCE_REQUEST_WIZARD_LOAD_STEP:
            step = action.data.step;
            isLoadingFromPublic = state.get('isLoadingFromPublic') && step !== 3;
            return state.merge({
                steps: updateStep(state.get('steps'), step, action),
                visibleStep: FLOW_STEPS[action.data.flowData.uiStep],
                wizardRequestResponse: WIZARD_REQUEST_RESPONSE_OPTIONS.NO_PROCESS,
                error: '',
                isLoadingFromPublic,
            });

        case actionTypes.INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP:
            step = action.data.step;
            return state.merge({
                steps: updateStep(state.get('steps'), step - 1, action),
                visibleStep: step
            });

        case actionTypes.INSURANCE_REQUEST_WIZARD_VALIDATE_STEP:
            step = action.data.step;
            partialSteps = updateStep(state.get('steps'), step - 1, action);
            const sizeOfWizardSteps = partialSteps.size;
            visibleStep = partialSteps.getIn([step - 1, 'valid']) ? step + 1 : step;
            visibleStep = visibleStep > sizeOfWizardSteps ? sizeOfWizardSteps : visibleStep;
            return state.merge({
                steps: partialSteps,
                visibleStep
            });

        case actionTypes.INSURANCE_REQUEST_WIZARD_SET_IS_LOADING_FROM_PUBLIC:
            return state.merge({
                isLoadingFromPublic: true
            })

        case actionTypes.INSURANCE_REQUEST_WIZARD_SET_DATA:
            step = action.data.step;
            delete action.data['step'];
            return state.merge({
                steps: updateStep(state.get('steps'), step, action)
            });

        case actionTypes.INSURANCE_REQUEST_COVERAGES_QUOTATION_REQUEST:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_QUOTATION_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_QUOTATION_FAILURE:
        case actionTypes.INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_REQUEST:
        case actionTypes.INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_GET_COVERAGES_AND_PLANS_TABLE_FAILURE:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_REQUEST:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_DETAIL_BASIC_DATA_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_REQUEST:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_DETAIL_HIGH_DATA_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_COVERAGES_DETAIL_DATA_FAILURE:
        case actionTypes.INSURANCE_REQUEST_CANCEL_SIMULATION_REQUEST:
        case actionTypes.INSURANCE_REQUEST_CANCEL_SIMULATION_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_CANCEL_SIMULATION_FAILURE:
        case actionTypes.INSURANCE_REQUEST_SELECT_BASIC_PLAN:
        case actionTypes.INSURANCE_REQUEST_SELECT_PLAN_REQUEST:
        case actionTypes.INSURANCE_REQUEST_SELECT_PLAN_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_SELECT_PLAN_FAILURE:
        case actionTypes.INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS:
            return state.merge({
                steps: updateStep(state.get('steps'), THIRD_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_SIMULATION_LINK_S3_CLIENT_FAILURE:
        case actionTypes.INSURANCE_REQUEST_SELECT_POPULATION_REQUEST:
        case actionTypes.INSURANCE_REQUEST_SELECT_POPULATION_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_SELECT_POPULATION_FAILURE:
        case actionTypes.INSURANCE_REQUEST_CHANGE_ERROR_POSTAL_CODE:
        case actionTypes.INSURANCE_REQUEST_CHANGE_ERROR_POPULATION:
        case actionTypes.INSURANCE_REQUEST_CLEAR_POSTAL_CODE_ERROR:
            partialSteps = updateStep(state.get('steps'), SECOND_STEP, action);
            partialSteps = updateStep(partialSteps, THIRD_STEP, action);
            return state.merge({
                steps: partialSteps
            });

        case actionTypes.INSURANCE_REQUEST_PRICING_REQUEST:
        case actionTypes.INSURANCE_REQUEST_PRICING_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_PRICING_FAILURE:
        case actionTypes.INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_SET_PAYMENT_ACCOUNT_FAILURE:
        case actionTypes.INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_GET_PAYMENT_ACCOUNT_FAILURE:
        case actionTypes.INSURANCE_REQUEST_PROVINCES_REQUEST:
        case actionTypes.INSURANCE_REQUEST_PROVINCES_FAILURE:
        case actionTypes.INSURANCE_REQUEST_PROVINCES_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_IN_PROGRESS:
        case actionTypes.INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_GET_ADDRESS_TYPE_LIST_FAILURE:
        case actionTypes.INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST:
        case actionTypes.INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_GET_MORTGAGE_BANK_LIST_FAILURE:
            return state.merge({
                steps: updateStep(state.get('steps'), FOURTH_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_SAVE_STEP_REQUEST:
        case actionTypes.INSURANCE_REQUEST_SAVE_STEP_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_SAVE_STEP_FAILURE:
            step = action.data.step;
            partialSteps = updateStep(state.get('steps'), step, action);

            return state.merge({
                steps: partialSteps,
                visibleStep: partialSteps.getIn([step, 'valid']) ? step + 2 : step + 1
            });

        case actionTypes.INSURANCE_REQUEST_GET_DOCUMENT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_GET_DOCUMENT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_GET_DOCUMENT_FAILURE:
        case actionTypes.INSURANCE_REQUEST_LOAD_DOCUMENTS_FOR_PREVIEW:
        case actionTypes.INSURANCE_REQUEST_DOCUMENT_READ:
        case actionTypes.SHOW_PRINT_REQUIRED:
            return state.merge({
                steps: updateStep(state.get('steps'), FIFTH_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_POST_WIZARD_SUCCESS:
            const { response } = action.data;
            return state.merge({
                wizardRequestResponse: WIZARD_REQUEST_RESPONSE_OPTIONS[response],
            });

        case actionTypes.INSURANCE_REQUEST_POST_WIZARD_ERROR:
            const { error } = action.data;
            return state.merge({
                wizardRequestResponse: WIZARD_REQUEST_RESPONSE_OPTIONS.ERROR,
                error,
            });

        case actionTypes.INSURANCE_REQUEST_POST_POLICY_PDF:
            const { base64string, base64url, base64type, base64name } = action.data.base64Response
            return state.mergeDeep({
                policyDocument: {
                    policyPdfUrl: base64url,
                    policyPdfBase64: base64string,
                    policyPdfName: base64name,
                    policyPdfType: base64type,
                }
            });

        case actionTypes.INSURANCE_REQUEST_WIZARD_CLEAR:
            return setInitialState();

        case actionTypes.INSURANCE_REQUEST_SET_AGREEMENT_CHECKBOX:
            return state.merge({
                steps: updateStep(state.get('steps'), FIFTH_STEP, action)
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestWizard;
module.exports.setInitialState = setInitialState;
